const BASE_URL = location.hostname.includes("rkeeper.ru")
  ? (location.hostname == 'test-rkeeper.ru' ? process.env["VUE_APP_API_URL"] : process.env["VUE_APP_API_URL"])
  : process.env["VUE_APP_API_URL_FOR_DEV"];

const RECAPTCHA_KEY = process.env["VUE_APP_RECAPTCHA_KEY"];

export const config = {
  baseUrl: BASE_URL,
  recaptcha: RECAPTCHA_KEY
};
